import { AbstractRouterFilter } from '@zk/framework-vue';
import beforeRouteLeave from '@/utils/beforeRouteLeave';
import NProgress from 'nprogress';

/**
 * 子应用离开过滤器
 * 执行子应用beforeRouteLeave钩子
 */
export default class MicroLeaveFilter extends AbstractRouterFilter {
  order() {
    return super.order() + 11;
  }

  matches(to, from) {
    return from.meta.micro;
  }

  async onBefore(to, from) {
    try {
      const result = await beforeRouteLeave(from, to);
      if (result === false) {
        NProgress.done();
      }
      return result;
    } catch (e) {
      NProgress.done();
      throw e;
    }
  }
}
